import { v4 as uuidv4 } from 'uuid';
import Store from './Store';

export default class MemoryEventStore implements Store {
  static clientGuid: string;

  sessionGuid?: string;

  clientFirstTouchedTimestamp?: number;

  sequenceNumber?: number;

  sessionTouched?: boolean;

  // eslint-disable-next-line class-methods-use-this
  getClientGuid(): string {
    if (typeof MemoryEventStore.clientGuid === 'undefined') {
      MemoryEventStore.clientGuid = uuidv4();
    }
    return MemoryEventStore.clientGuid;
  }

  getSessionGuid(): string {
    this.sessionGuid = this.sessionGuid || uuidv4();
    return this.sessionGuid;
  }

  getClientFirstTouchedTimestamp(): number {
    this.clientFirstTouchedTimestamp = this.clientFirstTouchedTimestamp || new Date().getTime();
    return this.clientFirstTouchedTimestamp;
  }

  getSequenceNumber(): number {
    this.sequenceNumber = this.sequenceNumber || 0;
    return this.sequenceNumber;
  }

  incrementSequenceNumber(): void {
    this.sequenceNumber = this.getSequenceNumber() + 1;
  }

  // mark the session as having started. return true iff the session had already started
  touchSession(): boolean {
    if (this.sessionTouched) {
      return false;
    }
    this.sessionTouched = true;
    return true;
  }
}
